export default {
    river: {
        url: 'support/search/river',
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'eu'],
    },
    delta: {
        url: 'support/search/delta',
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'eu'],
    },
};
